import { useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'

import { Header } from './components/Header'
import { Player } from './assets/data'
import { loadRoster } from './utils/roster'
// @ts-ignore
import './App.css'
import { PlayerDetails } from './components/PlayerDetails'
import Home from './components/Home'

function App() {
  const [playerArray, setPlayersArray] = useState([] as Player[])

  useEffect(() => {
    loadRoster().then(setPlayersArray)
  }, [])

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route index element={<Home players={playerArray} />} />
        <Route path="/players/:slug" element={<PlayerDetails players={playerArray} />} />
      </Routes>
    </div>
  )
}

export default App
